import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export function LandingPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        p: 4,
      }}
    >
      <Typography variant="h2" component="h1" fontWeight="bold">
        SaaS Boilerplate
      </Typography>

      <Typography variant="h5" color="text.secondary" textAlign="center" maxWidth={600}>
        A production-ready SaaS monorepo boilerplate. Start building faster.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        <Button variant="contained" size="large" component={Link} to="/register">
          Get Started
        </Button>
        <Button variant="outlined" size="large" component={Link} to="/dashboard">
          Dashboard
        </Button>
      </Box>
    </Box>
  );
}
